export enum TipoVisualizacaoSiloEnum {
    ISOMETRICA = 'ISOMETRICA',
    SUPERIOR = 'SUPERIOR',
}
